import { Pipe, PipeTransform } from "@angular/core";
import { Tools } from "@comunicare/comunicare-helper";

@Pipe({ name: "isDefined" })
export class IsDefinedPipe implements PipeTransform {
  transform(param1: unknown): boolean {
    return Tools.isDefined(param1);
  }
}
